import React, { useEffect, useState } from "react";
import { Plus, Check } from "lucide-react";
import { useLabText, labField } from "../../lib/labText";

export const QuestionField = ({ q, value, onChange, n }) => {
  const { t, pick, lang } = useLabText();
  const v = value || {};
  const [open, setOpen] = useState(!!v.comment);
  useEffect(() => { if (v.comment) setOpen(true); }, [v.comment]);
  const sel = Array.isArray(v.value) ? v.value : v.value ? [v.value] : [];
  const toggle = (id) => {
    if (q.type === "multi") onChange({ ...v, value: sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id] });
    else onChange({ ...v, value: id });
  };
  return (
    <fieldset data-testid={`lab-q-${q.id}`} className="space-y-3">
      <legend className="text-[15px] text-[#F2EBE1] leading-snug mb-3">
        <span className="text-[#C49A6C] me-2" dir="ltr">{n}.</span>{pick(q, "label")}
        {q.required && <span className="text-[10px] text-[#8A857D] ms-2 uppercase tracking-[0.15em]">· {t("required")}</span>}
      </legend>
      {q.type === "text" ? (
        <textarea rows={3} value={v.value || ""} onChange={(e) => onChange({ ...v, value: e.target.value })} className={labField} data-testid={`lab-a-${q.id}`} />
      ) : (
        <div className="grid gap-2">
          {q.options.map((o) => {
            const on = sel.includes(o.id);
            return (
              <button type="button" key={o.id} onClick={() => toggle(o.id)} data-testid={`lab-a-${q.id}-${o.id}`}
                className={`flex items-center gap-3 text-start px-4 py-3.5 border text-[15px] transition-colors ${on ? "border-[#C49A6C] bg-[#C49A6C]/10 text-[#F2EBE1]" : "border-[#2E2B27] text-[#B8B0A4] hover:border-[#5A5048]"}`}>
                <span className={`w-5 h-5 shrink-0 border flex items-center justify-center ${q.type === "multi" ? "" : "rounded-full"} ${on ? "border-[#C49A6C] bg-[#C49A6C] text-[#0B0A08]" : "border-[#5A5048]"}`}>{on && <Check size={12} />}</span>
                {lang === "ar" ? o.ar || o.en : o.en || o.ar}
              </button>
            );
          })}
        </div>
      )}
      {q.comment && (open ? (
        <textarea rows={2} autoFocus value={v.comment || ""} onChange={(e) => onChange({ ...v, comment: e.target.value })} placeholder={t("add_comment")} className={labField} data-testid={`lab-c-${q.id}`} />
      ) : (
        <button type="button" onClick={() => setOpen(true)} data-testid={`lab-add-c-${q.id}`} className="flex items-center gap-1.5 text-xs text-[#8A857D] hover:text-[#C49A6C] transition-colors">
          <Plus size={13} />{t("add_comment")}
        </button>
      ))}
    </fieldset>
  );
};
